export const fDirection = (data) => {
  const originObj = {
    direccion: `${data.street_from} ${data.exterior_number_from}, ${data.colonia_from}, ${data.zipcode_from}, ${data.city_from}, ${data.state_from}, Mexico`
  };

  const destinyObj = {
    direccion: `${data.street_to} ${data.exterior_number_to}, ${data.colonia_to}, ${data.zipcode_to}, ${data.city_to}, ${data.state_to}, Mexico`
  };

  return [originObj.direccion, destinyObj.direccion];
};
